module.exports = __webpack_public_path__ + "static/media/KC.981215cc.svg";